import { SvgIcon } from '@material-ui/core';
import React from 'react';

export const ContentCopyIcon = () => (
  <SvgIcon
    style={{ width: 'auto', height: 'auto', fill: 'none' }}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
      fill="currentColor"
    />
  </SvgIcon>
);
